import { render, staticRenderFns } from "./UiButtonNew.vue?vue&type=template&id=1fc0a4ec"
import script from "./UiButtonNew.vue?vue&type=script&lang=js"
export * from "./UiButtonNew.vue?vue&type=script&lang=js"
import style0 from "./UiButtonNew.vue?vue&type=style&index=0&id=1fc0a4ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports